export const PAYPAL_PAYMENT_TYPE = 'paypal';
export const STRIPE_PAYMENT_ELEMENT_CARD_PAYMENT_TYPE = 'stripe_payment_element_card';
export const CREDIT_PAYMENT_TYPE = 'credit';
export const LOYALTY_POINTS_PAYMENT_TYPE = 'le_points';
export const PROMO_PAYMENT_TYPE = 'promo';
export const VOUCHER_PAYMENT_TYPE = 'voucher';
export const BRAINTREE_PAYMENT_TYPE = 'braintree';
export const RAZORPAY_PAYMENT_TYPE = 'razorpay';
export const LATITUDE_PAYMENT_TYPE = 'latitude';
export const LATITUDE_GEM_PAYMENT_TYPE = 'latitude_gem';
export const LATITUDE_PAY_PAYMENT_TYPE = 'latitude_pay';
export const KLARNA_PAYMENT_TYPE = 'klarna';
export const QANTAS_PAYMENT_TYPE = 'qantas';
export const APPLE_PAY_PAYMENT_TYPE = 'applepay';
export const GOOGLE_PAY_PAYMENT_TYPE = 'googlepay';
export const FLIGHTS_CREDIT_PAYMENT_TYPE = 'flightcredits';

export const LATITUDE_ALL_TYPES = [LATITUDE_PAYMENT_TYPE, LATITUDE_GEM_PAYMENT_TYPE, LATITUDE_PAY_PAYMENT_TYPE];

export const PAYMENT_METHODS_NOT_ALLOWED_REFUND = [LATITUDE_PAYMENT_TYPE, LATITUDE_GEM_PAYMENT_TYPE];

export const PaymentsServiceProviders = [
  {
    title: 'Luxury Escapes Credit',
    value: 'le_credit',
  },
  {
    title: 'Stripe (Payment Element Card)',
    value: STRIPE_PAYMENT_ELEMENT_CARD_PAYMENT_TYPE,
  },
  {
    title: 'Paypal',
    value: BRAINTREE_PAYMENT_TYPE,
  },
  {
    title: 'Qantas',
    value: QANTAS_PAYMENT_TYPE,
  },
  {
    title: 'Latitude Gem',
    value: LATITUDE_GEM_PAYMENT_TYPE,
  },
  {
    title: 'LatitudePay',
    value: LATITUDE_PAY_PAYMENT_TYPE,
  },
  {
    title: 'Klarna',
    value: KLARNA_PAYMENT_TYPE,
  },
  {
    title: 'ApplePay',
    value: APPLE_PAY_PAYMENT_TYPE,
  },
  {
    title: 'GooglePay',
    value: GOOGLE_PAY_PAYMENT_TYPE,
  },
  {
    title: 'Razorpay',
    value: RAZORPAY_PAYMENT_TYPE,
  },
];

export const PaymentSchedulePaymentMethodTypes = {
  PayPalVaulting: 'paypal_vaulting',
  StripeOffSessionCard: 'stripe_off_session_cards',
  StripeSubscription: 'stripe_subscription',
};

export const PaymentSchedulePaymentMethodLabels: Record<string, string> = {
  [PaymentSchedulePaymentMethodTypes.PayPalVaulting]: 'PayPal',
  [PaymentSchedulePaymentMethodTypes.StripeOffSessionCard]: 'Stripe',
  [PaymentSchedulePaymentMethodTypes.StripeSubscription]: 'Stripe',
};

export function formatPaymentSchedulePaymentMethod(paymentMethod: string): string {
  return PaymentSchedulePaymentMethodLabels[paymentMethod] ?? paymentMethod;
}

export const PaymentScheduleChargeStatuses = {
  Cancelled: 'cancelled',
  Refunded: 'refunded',
  Paid: 'paid',
  Failed: 'failed',
  Pending: 'pending',
};

export const UPCOMING_PAYMENT_STATUS = 'upcoming_payment';
